module.exports = __webpack_public_path__ + "static/img/kawufumajiang.a010c4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/kawufumajiang.jpg
// module id = 1uPM
// module chunks = 0